import axios from 'axios';

const api = async (source) => {
  try {
    const response = await axios.get(source);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export default api;
